import { CognitoIdentityServiceProvider } from 'aws-sdk';
import { Dispatch, SetStateAction } from 'react';

type Config = {
  apiBaseUrl: string;
  defaultLandingPage: string;
  locationByHost?: Record<string, string>;
  titleByHost?: Record<string, string>;
  featuresByLocation?: Record<
    string,
    {
      enableMMP?: boolean;
      enableDarkMode?: boolean;
    }
  >;
  auth: {
    region: string;
    clientId: string;
    flow: string;
  };
};

type LoginStatus = UserAuthenticated.YES | UserAuthenticated.NO | UserAuthenticated.UNKNOWN;

type TokenStore = {
  accessToken: string;
  idToken: string;
  refreshToken: string;
};

type AuthContextType = {
  cognitoServiceProvider: CognitoIdentityServiceProvider;
  authStatus: LoginStatus;
  tokenStore: TokenStore;
  userLocation: string;
  email: string;
  updateEmail: any;
  updateAuthStatus: Dispatch<SetStateAction<LoginStatus>> | (() => {});
  updateTokenStore: Dispatch<SetStateAction<TokenStore>> | (() => {});
  updateRefreshTokenCookie: (token: string) => void;
};

export enum UserAuthenticated {
  YES,
  NO,
  UNKNOWN,
}

export type { AuthContextType, Config, LoginStatus };
